<template>
  <div
    :class="rootClass"
    @mouseenter="handleMouseIn"
    @mouseleave="handleMouseOut"
  >
    <LayeredCharacter :class="$style.imgContainer">
      <template #default="props">
        <img :class="[props.imgClass, imgClass]" :src="imgSrc" :style="imgStyle" />
      </template>
      <template #character="props">
        <Character :class="[props.characterClass, characterClass]" />
      </template>
    </LayeredCharacter>
    <div :class="$style.detail" v-if="!showApply">
      <Coin :n="item.price" :size="16" v-if="!showApply" />
      <div v-if="showApply" />
      <Anicss
        :enter-active-class="['animated', 'bounceIn']"
      >
        <IconButton
          v-if="hover && showPurchase"
          :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/cart-outline.svg')"
          :disabled="!purchaseable"
          @click="handlePurchase"
        >
          <template #icon="props">
            <SvgIcon :svg="props.svg" :size="24" />
          </template>
          <template #text="props"></template>
        </IconButton>
      </Anicss>
    </div>
    <div v-if="showApply" :class="showApplyControlClass">
      <IconButton
        rounded
        :class="showApplyControlBtnClass"
        :svg="require(`!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg`)"
        @click="handleItemApply"
      >
        <template #icon>
          <template v-if="applied && !hover">
            <SvgIcon :svg="require(`!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg`)" />
          </template>
          <template v-if="applied && hover">
            <SvgIcon :svg="require(`!svg-inline-loader?classPrefix!@mdi/svg/svg/close.svg`)" />
          </template>
          <template v-if="!applied">
            <SvgIcon :svg="require(`!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg`)" />
          </template>
        </template>
      </IconButton>
    </div>
  </div>
</template>

<script>
import IconButton from '@/components/IconButton'
import Character from '@/components/Character'
import Coin from '@/components/Coin'
import SvgIcon from '@/components/SvgIcon'
import Anicss from '@/components/Anicss'
import LayeredCharacter from '@/components/LayeredCharacter'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    IconButton,
    Character,
    Coin,
    SvgIcon,
    LayeredCharacter,
    Anicss,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    showPurchase: {
      type: Boolean,
      default: false,
    },
    showApply: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      hover: false,
    }
  },
  computed: {
    imgSrc () {
      const file = this.item.image
      return require(`!file-loader!@/assets/item/${file}`)
    },
    imgStyle () {
      return {
        'z-index': this.item.z_index,
      }
    },
    rootClass () {
      return [this.$style.root, {
        [this.$style.root_showApply]: this.showApply,
      }]
    },
    characterClass () {
      return [this.$style.character, {
        [this.$style.character_hover]: this.hover && !this.showApply,
      }]
    },
    imgClass () {
      return [{
        [this.$style.img_showApply]: this.showApply,
        [this.$style.img_showApply_hover]: this.showApply && this.hover,
        [this.$style.img_showApply_applied]: this.showApply && this.applied,
      }]
    },
    showApplyControlClass () {
      return [this.$style.showApplyControl, {
        [this.$style.showApplyControl_hover]: this.hover,
      }]
    },
    showApplyControlBtnClass () {
      return [this.$style.showApplyControlBtn, {
        [this.$style.showApplyControlBtn_applied]: this.applied,
        [this.$style.showApplyControlBtn_hover]: this.hover,
      }]
    },
    purchaseable () {
      if (this.isPurchasing) {
        return false
      }
      if (this.checkPurchased(this.item)) {
        return false
      }
      return true
    },
    applied () {
      return this.item.purchases.some((purchase) => purchase.apply)
    },
    hasEnoughBalance () {
      return this.item.price <= this.userBalance
    },
    ...mapGetters('auth', {
      userBalance: 'balance',
    }),
    ...mapGetters('shop', {
      isPurchasing: 'isPurchasing',
      checkPurchased: 'checkPurchased',
    }),
  },
  methods: {
    handleMouseIn () {
      this.hover = true
    },
    handleMouseOut () {
      this.hover = false
    },
    async handlePurchase () {
      if (!this.hasEnoughBalance) {
        this.$toasted.error('金幣不足')
        return
      }

      try {
        await this.purchase(this.item)
        this.$toasted.success('購買成功')
      } catch (e) {
        this.$toasted.error('發生錯誤')
      }
    },
    async handleItemApply () {
      try {
        if (this.applied) {
          await this.itemOff(this.item)
        } else {
          await this.itemOn(this.item)
        }
      } catch (e) {
        this.$toasted.error('發生錯誤')
      }
    },
    ...mapActions('shop', {
      purchase: 'purchase',
      itemOn: 'itemOn',
      itemOff: 'itemOff',
    }),
    ...mapActions('auth', {
    })
  },
}
</script>

<style lang="scss" module>
.root {
  box-shadow: 1px 1px 3px 1px #0000002b;
  display: grid;
  grid-template-rows: 170px 48px;
  grid-template-columns: 200px;
  grid-template-areas:
    "img"
    "detail";
  @apply overflow-hidden;
  @apply relative;
}

.root_showApply {
  grid-template-rows: 188px;
  grid-template-areas: "img";

  .imgContainer {
    @apply py-2;
  }
}

.imgContainer {
  grid-area: img;
  @apply px-2;
  z-index: 0;
}

.img {
  @apply w-full;
  @apply h-full;
  @apply object-center;
  @apply object-contain;
}

.img_showApply {
  opacity: 0.5;
}

.img_showApply_applied {
  //
}

.img_showApply_hover {
  //
}

.character {
  opacity: 0;
  transition: all .7s;
}

.character_hover {
  opacity: 0.6;
}

.detail {
  @apply px-2;
  @apply py-1;
  grid-area: detail;
  z-index: 1;
  @apply flex;

  > :nth-child(1) {
    @apply flex-grow;
  }
}

.purchaseButtonText {
  font-size: 1rem;
}

.showApplyControl {
  @apply absolute;
  @apply inset-0;
}

.showApplyControl_hover {
  background-color: rgba(0,0,0,0.3);
  transition: all .3s;
}

.showApplyControlBtn {
  @apply absolute;
  opacity: 0;
  width: 56px;
  height: 56px;
  top: calc(50% - 28px);
  right: calc(50% - 28px);
  transition: all .3s;

  &, &:active {
    transform: scale(0);
  }
}

.showApplyControlBtn_applied {
  opacity: 1;
  right: 0.5rem;
  top: 0.5rem;

  &, &:active {
    transform-origin: top right;
    transform: scale(0.7) translate(0);
  }
}

.showApplyControlBtn_hover {
  opacity: 1;
  top: calc(50% - 28px);
  right: calc(50% - 28px);

  &, &:active {
    transform: scale(1);
  }
}
</style>
